<template>
    <div class="row m-1 w-100">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        >
        </go-lotus-side-menu>

        <div class="col-12 col-sm-7 col-md-6 main-content position-relative">
            <section>
                <h3 class="text-primary">Upgrade Now</h3>
                <p class="mb-4">
                    For a limited time we are offering discounted prices. Upgrade now, be our early
                    adopters, let us know what you like and how we can do better. Join us to make
                    goLOTUS even more amazing!
                </p>

                <hr class="bar my-4" />

                <h5 class="my-4">Select your billing cycle:</h5>
                <form>
                    <fieldset class="form-group">
                        <div class="row">
                            <div class="col-12" v-show="loading && !plans.length">
                                <p class="font-italic">
                                    <i class="fa fa-spin fa-circle-o-notch mr-2"></i>
                                    Loading plans...
                                </p>
                            </div>
                            <div class="col-12" v-show="plans.length">
                                <div class="form-check" v-for="p in monthlyPlans">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        :id="p.id"
                                        v-model="plan"
                                        :value="p.id"
                                    />
                                    <label class="form-check-label" :for="p.id">
                                        {{ p.nickname }}
                                        <span
                                            >(${{ p.amount.toFixed(2) }} per seat per
                                            {{ p.interval }} plus sales tax where applicable)</span
                                        >
                                    </label>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>

                <h4>Enter your billing details</h4>

                <div class="bg-white border-light p-3 mt-2 paymentf">
                    <coupon-widget
                        :user="user"
                        @valid-coupon="coupon = $event"
                        @invalid-coupon="coupon = null"
                        @safeToSubmitChange="handleCouponSafeToSubmit"
                    ></coupon-widget>
                </div>

                <div class="bg-white border-light p-3 mt-2 mb-3 paymentf">
                    <div class="form-group">
                        <div class="row">
                            <div class="col mb-3">
                                <label>Cardholder name</label>
                                <input
                                    id="cardholder-name"
                                    v-model="cardholderName"
                                    class="form-control"
                                    placeholder="Cardholder name"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label>Card Information</label>
                                <div id="stripe-card" class="form-control"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="errorMsg" class="alert alert-danger">
                    <a href="#" class="close" data-dismiss="alert">&times;</a>
                    <strong>Error!</strong> {{ errorMsg }}
                </div>

                <div class="action-buttons">
                    <div class="w-100 d-flex justify-content-between">
                        <button
                            id="upgrade"
                            class="btn btn-primary font-weight-bold text-white mb-5"
                            @click.prevent="checkout"
                        >
                            Upgrade
                        </button>
                    </div>
                </div>
            </section>
        </div>

        <div class="col-12 col-sm-5 col-md-4">
            <div class="border-light mt-3">
                <div class="yellow text-center p-2">
                    <h4 class="text-white mb-0">Upgrade Today</h4>
                </div>
                <div
                    v-if="plans && plans.length"
                    class="bg-white w-100 d-flex justify-content-center flex-column align-items-center p-3"
                >
                    <div>
                        <div class="text-center">
                            <span class="position-relative discount-price text-primary"
                                >${{ plans.find(p => p.interval === "month").amount }}</span
                            >
                        </div>
                        <div class="text-center small text-muted">per user/month</div>
                    </div>
                    <!--                    <div>or</div>
                   <div>
                        <div class="text-center">
                            <span class="position-relative discount-price text-primary"
                                >${{ plans.find(p => p.interval === "year").amount }}</span
                            >
                        </div>
                        <div class="text-center small text-muted">
                            per user/year a ${{
                                plans.find(p => p.interval === "month").amount * 12 -
                                    plans.find(p => p.interval === "year").amount
                            }}
                            dollar savings
                        </div>
                    </div>-->
                </div>
                <div class="light-yellow text-center p-3">
                    <strong>Accounts Include:</strong>
                    <p class="mb-0">Customizable Data Trackers</p>
                    <p class="mb-0">Unlimited Clients</p>
                    <p class="mb-0">Automatic SOAP Note Generation</p>
                    <p class="mb-0">Therapist and Caregiver Signatures</p>
                    <p class="mb-0">Scheduling for Clients & Staff</p>
                    <p class="mb-0">EMR & EHR Data Storage</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpers } from "../plugins/helpers";
import { sideMenuItems } from "../plugins/sideMenuItems";
import GoLotusSideMenu from "./GoLotusSideMenu";
import CouponWidget from "./widgets/CouponWidget";

export default {
    name: "Upgrade",
    props: ["user", "organization", "intent"],
    mixins: [sideMenuItems],
    components: { GoLotusSideMenu, CouponWidget },
    data() {
        return {
            reactivate: false,
            plan: null,
            plans: [],
            loading: false,
            coupon: null,
            errorMsg: null,
            isSafeToSubmitCoupon: true,
            cardholderName: "",
        };
    },
    created() {
        this.getBasicPlans();
    },
    mounted() {
        this.cardholderName = "";
        helpers.mountStripeElement();
    },
    computed: {
        monthlyPlans() {
            return this.plans.filter(plan => plan.interval === "month");
        },
    },
    methods: {
        getBasicPlans() {
            this.loading = true;
            axios
                .get(`/api/plans`)
                .then(r => {
                    this.plans = r.data;
                    let plan = this.plans.find(plan => plan.interval === "month");
                    if (plan) {
                        this.plan = plan.id;
                    }
                    this.loading = false;
                })
                .catch(e => {
                    console.error(e);
                    this.loading = false;
                });
        },

        async checkout() {
            // make sure user has validated their validCoupon if it exists
            if (!this.isSafeToSubmitCoupon) {
                this.loading = false;
                this.errorMsg =
                    "You must verify the coupon before continuing. Remove the coupon if you won't be using it.";
                return;
            }

            if (!this.plan) {
                this.errorMsg = "You must select a plan in order to continue.";
                return;
            }

            helpers.toggleSpinner("upgrade");

            const { setupIntent, error } = await stripe.handleCardSetup(
                this.intent.client_secret,
                card,
                {
                    payment_method_data: {
                        billing_details: { name: this.cardholderName },
                    },
                }
            );

            if (error) {
                helpers.toggleSpinner("upgrade");
                this.$swal("Error", `Something went wrong authorizing your card.`, "error");
            } else {
                this.createSubscription(setupIntent);
            }
        },

        handleCouponSafeToSubmit(isSafe) {
            this.isSafeToSubmitCoupon = isSafe;
            this.errorMsg = null;
        },

        createSubscription(setupIntent) {
            let payload = {
                setupIntent,
                plan: this.plan,
                cardholderName: this.cardholderName,
            };
            if (this.coupon) {
                payload.coupon = this.coupon;
            }
            axios
                .post(`/api/users/${this.user.id}/subscription/new`, payload)
                .then(r => {
                    this.$swal(
                        "Thank you for subscribing to goLOTUS!️",
                        `Your account was successfully updated.`,
                        "success"
                    ).then(_ => (window.location = "/account"));
                })
                .catch(e => {
                    helpers.toggleSpinner("upgrade");
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped>
.pricing-plan {
    border: solid 1px #d64571;
    flex-basis: 0;
    flex-grow: 1;
}
.save-tag {
    position: absolute;
    right: -1rem;
    top: 1rem;
    z-index: 2;
    background-color: #fff1c3;
}

.full-price {
    font-size: 20px;
}

.discount-price {
    font-size: 28px;
}

.slash {
    width: 40px;
    height: 1px;
    color: #d64571;
    background-color: #d64571;
    border-color: #d64571;
    z-index: 2;
    transform: rotate(-30deg);
    position: absolute;
    left: -2px;
    bottom: -4px;
}

.yellow {
    background-color: #f8b92b;
}

.light-yellow {
    background-color: #feefcb;
}
</style>
